import React from 'react';
import ActualizacionMasivaFeeLogistico from "./ActualizacionMasivaFeeLogistico";
import TablaFeeLogistico from "../TablaFeeLogistico";
import NewFee from "../FeeNew";
import TablaFee from "../TablaFee";
import LogisticaPropia from '../../../../Sellers/LogisticaPropia';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

class ActualizacionMasivaLiquidaciones extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabs: []
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.seller?.envioPropio && prevProps.seller !== this.props.seller) {
      const tabExists = this.state.tabs.some(tab => tab.name === "Logística Propia");
      if (!tabExists) {
        this.setState((prevState) => ({
          tabs: [
            ...prevState.tabs,
            {
              name: "Logística Propia",
              icon: "ti-home",
              content: <LogisticaPropia idSeller={this.props.idSeller} userType={this.props.userType} />
            }
          ]
        }));
      }
    }
  }

  goToFeeNuevo = () => {
    this.props.navigate('/Liquidaciones/NuevoFee');
  };

  render() {
    const { idSeller, userType } = this.props;

    return (
      <div className="container">
        <div className="row page-titles text-center text-md-start">
          <div className="row align-items-center justify-content-between page-titles">
            <div className="col-12 col-md-6">
              <h3 className="text-themecolor color-rojo-megatone">Fee Logistico</h3>
            </div>

            <div className="col-12 col-md-6 text-end">
              <button
                type="button"
                className="btn btn-sm btn-green"
                onClick={this.goToFeeNuevo}
              >
                <i className="fa fa-plus-circle" /> Crear Fee
              </button>
            </div>
          </div>


          <div className="col-12 mt-4">
            <TablaFee idSeller={idSeller} userType={userType} titulo="Fee Anterior" />
          </div>

          <div className="col-12 mt-4">
            <TablaFee idSeller={idSeller} userType={userType} titulo="Fee Activo" />
          </div>

          <div className="col-12 mt-4">
            <TablaFee idSeller={idSeller} userType={userType} titulo="Fee Próximo" />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  idSeller: state.sellers.currentSellerId,
  userType: state.general.userType,
  seller: state.sellers.seller,
});

const ConnectedComponent = connect(mapStateToProps)(ActualizacionMasivaLiquidaciones);

export default function Wrapper(props) {
  const navigate = useNavigate();
  return <ConnectedComponent {...props} navigate={navigate} />;
}
